// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { needHelpStyles } from "@west/App/Widgets/Header/NeedHelp";
import Email from "@west/XDL/Icons/Email";
import Help from "@west/XDL/Icons/Help";
import HelpText from "@west/XDL/Icons/HelpText";
import LiveChat from "@west/XDL/Icons/LiveChat";
import Phone from "@west/XDL/Icons/Phone";
import { color, xScreen } from "@west/XDL/Utilities";
import { css } from "styled-components";

needHelpStyles.component = {
    container: {
        css: css`
            width: 404px;
            ${xScreen("lte", "md")} {
                width: 100%;
                padding: 8px 16px;
            }
        `,
    },
    titleContainer: {
        css: css`
            width: 100%;
            border-bottom: 1px solid ${color("common.border")};
            padding-bottom: 8px;
            margin-bottom: 16px;
        `,
    },
    title: {
        size: 18,
        color: "text.main",
        weight: "bold",
        css: css`
            letter-spacing: 0;
            line-height: 24px;
        `,
    },
    contactUsContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 16px 14px;
            margin-bottom: 20px;

            ${xScreen("lte", "md")} {
                flex-direction: column;
                justify-content: flex-start;
            }
        `,
    },
    contactUsLinkWrapper: {
        css: css`
            width: calc(50% - 7px);
        `,
    },
    contactUsDescription: {
        variant: "p",
        size: 12,
        weight: "normal",
        css: css`
            letter-spacing: 0;
            line-height: 16px;
            width: 100%;
            margin-bottom: 12px;

            & > ${TypographyStyle} {
                font-size: inherit;
                font-weight: inherit;
                line-height: inherit;
                letter-spacing: inherit;
                margin-bottom: 0;
            }
        `,
    },
    liveChat: {
        color: "text.main",
        icon: {
            iconProps: {
                src: LiveChat,
                color: "text.link",
            },
        },
    },
    email: {
        color: "text.main",
        icon: {
            iconProps: {
                src: Email,
                color: "text.link",
            },
        },
        typographyProps: {
            transform: "initial",
        },
    },
    phoneCall: {
        color: "text.main",
        typographyProps: {
            weight: "normal",
            css: css`
                display: flex;
                flex-direction: column;
                gap: 4px;
                & > ${TypographyStyle} {
                    font-size: inherit;
                    font-weight: bold;
                    letter-spacing: inherit;
                    line-height: inherit;
                }
            `,
        },
        icon: {
            iconProps: {
                src: Phone,
                color: "text.link",
            },
        },
        css: css`
            align-items: flex-start;
        `,
    },
    phoneText: {
        color: "text.main",
        typographyProps: {
            weight: "normal",
            css: css`
                display: flex;
                flex-direction: column;
                gap: 4px;
                & > ${TypographyStyle} {
                    font-size: inherit;
                    font-weight: bold;
                    letter-spacing: inherit;
                    line-height: inherit;
                }
            `,
        },
        icon: {
            iconProps: {
                src: HelpText,
                color: "text.link",
            },
        },
        css: css`
            align-items: flex-start;
        `,
    },
    supportLinksContainer: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            row-gap: 12px;

            ${xScreen("lte", "md")} {
                flex-direction: column;
                justify-content: flex-start;
            }
        `,
    },
    supportLinkWrapper: {
        css: css`
            width: 42%;
        `,
    },
    supportLink: {
        color: "text.main",
        typographyProps: {
            weight: "normal",
        },
    },
};

needHelpStyles.headerClickableStyles = {
    icon: {
        src: Help,
        css: css`
            ${xScreen("lte", "md")} {
                &,
                & > svg {
                    width: 23px;
                    height: 18px;
                }
            }
        `,
    },
};
